<!-- 用人理念 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_team.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="用人理念" en="EMPLOYMENT CONCEPT"></sub-title>
        <div class="pyramid-box">
          <img
            src="http://api.zyzxgc.cn/file/static/pyramid.png"
            class="post"
          />
          <div class="text text1"><span>留人：</span>共创共赢、助梦达成。</div>
          <div class="text text2"><span>用人：</span>扬长避短、激发潜力。</div>
          <div class="text text3"><span>育人：</span>内外兼修、持续赋能。</div>
          <div class="text text4"><span>选人：</span>选贤举能，任人唯贤。</div>
          <div class="text text5">
            <span>人才标准</span>
          </div>
          <div class="text text6">重视贡献<span>（价值）</span></div>
          <div class="text text7">结果导向<span>（结果）</span></div>
          <div class="text text8">善于学习<span>（进步）</span></div>
          <div class="text text9">拥抱责任<span>（担当）</span></div>
        </div>
        <div class="m-box">
          <img src="http://api.zyzxgc.cn/file/static/m_idea.png" alt="" />
        </div>
        <div class="tip">
          <span>选育用留：</span>
          公司人才培育体系健全科学，人才选育用留理念：“选人：选贤举能、任人唯贤；育人：内外兼修、持续赋能；用人：扬长避短、激发潜力；留人：共创共赢、助梦达成”。公司推行“雏鹰计划、飞鹰计划、雄鹰计划”三阶段人才培育体系，实现人才从“小白”到“骨干”的蜕变。
        </div>
      </div>
      <div class="pc">
        <div class="tabs w1200">
          <div
            :class="{ tab: true, active: activeTab == 0 }"
            @click="choseTab(0)"
          >
            <div class="title">基层用人</div>
            <div class="en">GRASS-ROOTS EMPLOYMENT</div>
          </div>
          <div
            :class="{ tab: true, active: activeTab == 1 }"
            @click="choseTab(1)"
          >
            <div class="title">中层用人</div>
            <div class="en">MIDDLE-LEVEL PERSONNEL</div>
          </div>
          <div
            :class="{ tab: true, active: activeTab == 2 }"
            @click="choseTab(2)"
          >
            <div class="title">高层用人</div>
            <div class="en">SENIOR PERSONNEL</div>
          </div>
        </div>
        <div class="content">
          <div class="base">
            <div class="left">
              <div
                :class="{ item: true, active: activeType == '选' }"
                @mouseenter="choseType('选')"
              >
                选
              </div>
              <div
                :class="{ item: true, active: activeType == '育' }"
                @mouseenter="choseType('育')"
              >
                育
              </div>
              <div
                :class="{ item: true, active: activeType == '用' }"
                @mouseenter="choseType('用')"
              >
                用
              </div>
              <div
                :class="{ item: true, active: activeType == '留' }"
                @mouseenter="choseType('留')"
              >
                留
              </div>
            </div>
            <div class="right" v-if="tabs[activeTab][activeType]">
              <div class="title">{{ tabs[activeTab][activeType].title }}</div>
              <div class="sub">
                {{ tabs[activeTab][activeType].sub }}
              </div>
              <div
                class="info"
                v-html="tabs[activeTab][activeType].detail"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="m">
        <div
          :class="{ collapse: true, active: activeTab == 0 }"
          @click="changeCollapse(0)"
        >
          <div class="top">
            <div class="point"></div>
            <div class="title">基层用人</div>
            <div class="en">GRASS-ROOTS EMPLOYMENT</div>
            <div class="btn">
              <i class="el-icon-plus" v-show="0 != activeTab"></i>
              <i class="el-icon-minus" v-show="0 == activeTab"></i>
            </div>
          </div>
          <div class="bottom" v-show="0 == activeTab">
            <div class="types">
              <div
                :class="{ type: true, active: activeType == '选' }"
                @click="choseType('选')"
              >
                选
              </div>
              <div
                :class="{ type: true, active: activeType == '育' }"
                @click="choseType('育')"
              >
                育
              </div>
              <div
                :class="{ type: true, active: activeType == '用' }"
                @click="choseType('用')"
              >
                用
              </div>
              <div
                :class="{ type: true, active: activeType == '留' }"
                @click="choseType('留')"
              >
                留
              </div>
            </div>
            <div class="right" v-if="tabs[activeTab][activeType]">
              <div class="title">{{ tabs[activeTab][activeType].title }}</div>
              <div class="sub">
                {{ tabs[activeTab][activeType].sub }}
              </div>
              <div
                class="info"
                v-html="tabs[activeTab][activeType].detail"
              ></div>
            </div>
          </div>
        </div>
        <div
          :class="{ collapse: true, active: activeTab == 1 }"
          @click="changeCollapse(1)"
        >
          <div class="top">
            <div class="point"></div>
            <div class="title">中层用人</div>
            <div class="en">MIDDLE-LEVEL PERSONNEL</div>
            <div class="btn">
              <i class="el-icon-plus" v-show="1 != activeTab"></i>
              <i class="el-icon-minus" v-show="1 == activeTab"></i>
            </div>
          </div>
          <div class="bottom" v-show="1 == activeTab">
            <div class="types">
              <div
                :class="{ type: true, active: activeType == '选' }"
                @click="choseType('选')"
              >
                选
              </div>
              <div
                :class="{ type: true, active: activeType == '育' }"
                @click="choseType('育')"
              >
                育
              </div>
              <div
                :class="{ type: true, active: activeType == '用' }"
                @click="choseType('用')"
              >
                用
              </div>
              <div
                :class="{ type: true, active: activeType == '留' }"
                @click="choseType('留')"
              >
                留
              </div>
            </div>
            <div class="right" v-if="tabs[activeTab][activeType]">
              <div class="title">{{ tabs[activeTab][activeType].title }}</div>
              <div class="sub">
                {{ tabs[activeTab][activeType].sub }}
              </div>
              <div
                class="info"
                v-html="tabs[activeTab][activeType].detail"
              ></div>
            </div>
          </div>
        </div>
        <div
          :class="{ collapse: true, active: activeTab == 2 }"
          @click="changeCollapse(2)"
        >
          <div class="top">
            <div class="point"></div>
            <div class="title">高层用人</div>
            <div class="en">SENIOR PERSONNEL</div>
            <div class="btn">
              <i class="el-icon-plus" v-show="2 != activeTab"></i>
              <i class="el-icon-minus" v-show="2 == activeTab"></i>
            </div>
          </div>
          <div class="bottom" v-show="2 == activeTab">
            <div class="types">
              <div
                :class="{ type: true, active: activeType == '选' }"
                @click="choseType('选')"
              >
                选
              </div>
              <div
                :class="{ type: true, active: activeType == '育' }"
                @click="choseType('育')"
              >
                育
              </div>
              <div
                :class="{ type: true, active: activeType == '用' }"
                @click="choseType('用')"
              >
                用
              </div>
              <div
                :class="{ type: true, active: activeType == '留' }"
                @click="choseType('留')"
              >
                留
              </div>
            </div>
            <div class="right" v-if="tabs[activeTab][activeType]">
              <div class="title">{{ tabs[activeTab][activeType].title }}</div>
              <div class="sub">
                {{ tabs[activeTab][activeType].sub }}
              </div>
              <div
                class="info"
                v-html="tabs[activeTab][activeType].detail"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
      activeTab: 0,
      activeType: "选",
      tabs: [
        {
          选: {
            title: "选人：招聘与面试",
            sub: "（以德为先、严谨的工作态度、对行业的高度热爱、技能测试、抗压测试）",
            detail: `<span>候选人类型：</span>\n应届毕业生、职场新人。`,
          },
          育: {
            title: "育人：雏鹰带教计划",
            sub: "企业文化 （传）、职业生涯 规划（帮）、专业技能 （带）、入职仪式 手续/转正 仪式手续、考试测评、公司制度）",
            detail: `<span>1.  业务线：</span>\n由责任导师与专业讲师共同担任，采用集中授课制和个性化辅导并行的方式进行授课培训。------ 系统支撑：导师带教计划表（业务线）\n<span>2.  人力资源线：</span>\n采用集中增训与专人跟踪辅导的方式进行培训。------ 系统支撑：导师带教计划表（人力资源线）`,
          },
          用: {
            title: "用人：试用期考评与正式人员考评",
            sub: "（入职7天跟踪、入职1个月初评、月度评价）",
            detail: `<span>1.  试用期考评：</span>\n综合考评，确定合适人选。\n<span>2.  正式人员考评：</span>\n进行月度考评与项目阶段评价， 阶梯成长，稳健提升。`,
          },
          留: {
            title: "留人：机制支撑",
            sub: "（师徒制、晋升机制(结果导向)、ppv量化薪酬）",
            detail: `<span>1.  成长帮扶制（师徒制）：</span>\n由固定导师负责新人专业成长及个人职业生涯规划帮扶（公司集中面授专业基本功+工程现场学习），并建立以导师考核制+学员考评制为主的双向考核机制，不断提升员工专业能力。\n<span>2.  薪资机制：</span>\n包含PPV（量化薪酬）与补贴。\n<span>3.  晋升机制：</span>\n以结果为导向，决定晋升（公司每月统一组织技能测评，凭结果晋升）。`,
          },
        },
        {
          选: {
            title: "选人：内部选拔+胜任力评估",
            sub: "（自主申请、内部选拔、综合性人才）",
            detail: `<span>候选人类型：</span>\n内部标杆基层人物、外部优秀人才。`,
          },
          育: {
            title: "育人：飞鹰带教计划",
            sub: "（工作习惯、职业素养、专业技能、管理技能）",
            detail: `<span>1.  选人：</span>本人自主申请，公司进行综合评估，包含学习力评估（时间、费用）。\n<span>2.  培养： 业务线（工作技能）：</span>由责任导师与专业讲师对其进行培养，采用集中授课制与个性化辅导相结合进行授课培训。\n------ 系统支撑：导师带教计划表（业务线）\n<span>职能线（综合技能）：</span>以职业素养、工作习惯、技能（非专业）三方面为主，由外部培训机构和公司人力资源部联合完成。\n---- 系统支撑：导师带教计划表（人力资源线）\n<span>3.  结果评价机制：</span>考试测评+岗位试岗。`,
          },
          用: {
            title: "用人：考评、激励机制",
            sub: "（双规考核、多重激励、四维评估）",
            detail: `<span>1.  双轨考核机制：</span>过程控制与结果导向相结合。\n<span>2.  四维人才评估：</span>从立场、状态、结果、空间四个维度进行综合评估。\n<span>3.  激励机制：</span>从物质激励、柔性激励、负面激励、长效激励四个方面进行多重激励。`,
          },
          留: {
            title: "留人：机制支撑",
            sub: "（师徒制、晋升机制(结果导向)、KSF+PPV(量化薪酬、合伙人激励））",
            detail: `<span>1.  成长帮扶制：</span>帮助其制定职业规划，并进行跟踪辅导，建立以导师考核制与学员考评制为核心的双向考核机制。\n<span>2.  薪资机制：</span>包含KSF+PPV（量化薪酬）、以项目或部门为单位的合伙人激励，以及各类补贴。\n<span>3.  晋升机制：</span>以结果晋升，通过公司人才选拔（公司每年统一组织2-4次） 。`,
          },
        },
        {
          选: {
            title: "选人：内部选拔+胜任力评估",
            sub: "（高度的担当责任心、强烈的意愿度、高度符合公司用人价值观、学习能力）",
            detail: `<span>候选人类型：</span>\n内部标杆中层人物、外部优秀管理人才。`,
          },
          育: {
            title: "育人：雄鹰带教计划",
            sub: "（公司领导辅导、外部专业机构培训、行业培训）",
            detail: `<span>1.  选人：</span>本人自主申请、高度认同公司价值观、愿意持续学习，并为之投入相应的学习成本（时间、费用）。\n<span>2.  培养：</span>专业外部培训机构、行业培训、公司领导辅导。\n<span>3.  结果评价：</span>通过岗位考核，并使公司管理升级（学习转化力）。`,
          },
          用: {
            title: "用人：考评、激励机制",
            sub: "（双轨考核、多重激励、四维评估）",
            detail: `<span>1.  双轨考核机制：</span>过程控制与结果导向相结合。\n<span>2.  四维人才评估：</span>从立场、状态、结果、空间四个维度进行综合评估。\n<span>3.  激励机制：</span>从物质激励、柔性激励、负面激励、长效激励四个方面进行多重激励。`,
          },
          留: {
            title: "留人：机制支撑",
            sub: "（金色降落伞、高级合伙人激励、股权分红、KSF （绩效薪资））",
            detail: `<span>1.  薪资机制：</span>KSF（绩效薪资）与高级合伙人激励金。\n<span>2.  晋升机制：</span>以结果晋升，通过公司人才选拔（公司每年统一组织1-2次）。\n<span>3.  未来规划：</span>享受股权分红与金色降落伞保障。`,
          },
        },
      ],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    // 切换用人层级
    choseTab(idx) {
      this.activeTab = idx;
    },
    choseType(type) {
      this.activeType = type;
    },
    // 移动端手风琴
    changeCollapse(idx) {
      this.activeTab = idx;
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/idea_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 30px;

    .m-box {
      display: none;
    }
    .pyramid-box {
      width: fit-content;
      margin: 70px auto;
      position: relative;

      .text {
        position: absolute;
        font-size: 18px;
        color: #5e5d5d;

        span {
          font-size: 24px;
          color: $theme;
        }
      }
      .text1 {
        left: -10px;
        top: -30px;
      }
      .text2 {
        left: -95px;
        top: 27%;
      }
      .text3 {
        left: -180px;
        top: 60%;
      }
      .text4 {
        left: -267px;
        top: 92%;
      }
      .text5 {
        right: 130px;
        top: -30px;
      }
      .text6 {
        right: -8px;
        top: 17%;
      }
      .text7 {
        right: -98px;
        top: 43%;
      }
      .text8 {
        right: -175px;
        top: 66%;
      }
      .text9 {
        right: -243px;
        top: 92%;
      }
    }
    .tip {
      font-size: 15px;
      color: #5e5d5d;
      line-height: 30px;
      margin-bottom: 70px;
    }
  }
  .tabs {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 60px;

    .tab {
      padding: 20px 0 40px;
      color: #454545;
      text-align: center;
      opacity: 0.7;
      cursor: pointer;

      &:hover {
        opacity: 1;
      }

      .title {
        font-size: 44px;
      }
      .en {
        font-size: 18px;
        margin-top: 20px;
      }
    }
    .active {
      opacity: 1;
      position: relative;

      &::before {
        content: "";
        display: block;
        width: 18px;
        height: 18px;
        background: #a01b1b;
        position: absolute;
        left: 50%;
        top: -18px;
        transform: translateX(-50%) rotate(45deg);
      }
      &::after {
        content: "";
        display: block;
        width: 68px;
        height: 3px;
        background-color: $theme;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
      }
    }
  }

  .content {
    margin-bottom: 120px;
  }
  .base {
    height: 670px;
    background-image: url("http://api.zyzxgc.cn/file/static/jiceng_bg.png");
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;

    .left {
      margin-right: 70px;
      position: relative;

      &::after {
        content: "";
        display: block;
        width: 2px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        background-color: rgba($color: #fff, $alpha: 0.15);
      }

      .item {
        width: 26vw;
        height: 100px;
        line-height: 100px;
        color: #fff;
        font-size: 48px;
        text-align: right;
        padding-right: 40px;
        box-sizing: border-box;
        cursor: pointer;
        border-right: 2px solid transparent;
        transition: 0.5s;

        &:hover {
          background-color: rgba($color: #fff, $alpha: 0.16);
          border-color: #fff;
        }
      }
      .active {
        background-color: rgba($color: #fff, $alpha: 0.16);
        border-color: #fff;
      }
    }
    .right {
      width: 60vw;
      height: 350px;
      padding: 0 20px 0 50px;
      box-sizing: border-box;
      box-shadow: 0px 3px 21px 0px rgba(5, 58, 122, 0.3);
      background-color: rgba($color: #fff, $alpha: 0.9);
      display: flex;
      flex-direction: column;
      justify-content: center;

      .title {
        font-size: 24px;
        color: #134178;
      }
      .sub {
        font-size: 15px;
        color: #5e5d5d;
        margin-top: 15px;
      }
      .type {
        color: #454545;
        margin-top: 25px;
        font-weight: bold;
      }
      .info {
        color: #5e5d5d;
        font-size: 15px;
        margin-top: 15px;
        line-height: 2;
        white-space: pre-wrap;

        :deep(span) {
          font-weight: bold;
        }
      }
    }
  }
}
.m {
  display: none;
}

@media (max-width: 1700px) {
  .frame .base {
    height: 550px;

    .right {
      height: 300px;
    }
  }
}

@media (max-width: 1400px) {
  .frame .base {
    height: 480px;
  }
}

@media (max-width: 750px) {
  .pc {
    display: none;
  }
  .m {
    display: block;
  }
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .pyramid-box {
        display: none;
      }
      .m-box {
        margin: 20px 0 10px;
        display: block;

        img {
          width: 100%;
        }
      }
      .tip {
        font-size: 14px;
        line-height: 1.8;
        margin-bottom: 20px;

        span {
          font-weight: bold;
        }
      }
    }
    .m {
      margin-bottom: 30px;
    }
    .collapse {
      &:last-child {
        .top {
          border-bottom: 1px solid #0b3a70;
        }
      }
      .top {
        margin: 0 20px;
        border-top: 1px solid #0b3a70;
        padding: 14px 10px;
        display: flex;
        align-items: center;

        .point {
          width: 8px;
          height: 8px;
          transform: rotate(45deg);
          background-color: #a19f9d;
        }
        .title {
          font-size: 14px;
          margin-left: 10px;
          color: #5e5d5d;
        }
        .en {
          font-size: 10px;
          margin-left: 20px;
        }
        .btn {
          margin-left: auto;
        }
      }
      .bottom {
        padding: 20px 20px 20px 0;
        margin-bottom: 20px;
        background-image: url("http://api.zyzxgc.cn/file/static/jiceng_bg.png");
        background-size: 90% 100%;
        background-repeat: no-repeat;
        display: flex;
        align-items: flex-start;

        .types {
          width: 20%;
          flex-shrink: 0;
          margin-right: 20px;
          border-right: 1px solid rgba(255, 255, 255, 0.15);

          .type {
            height: 70px;
            line-height: 70px;
            padding-left: 33px;
            font-size: 20px;
            color: #fff;
            border-right: 2px solid transparent;
          }
          .active {
            background-color: rgba($color: #fff, $alpha: 0.16);
            border-color: #fff;
          }
        }
        .right {
          flex-grow: 1;
          padding: 20px 15px;
          box-sizing: border-box;
          box-shadow: 0px 3px 21px 0px rgba(5, 58, 122, 0.3);
          background-color: rgba($color: #fff, $alpha: 0.9);
          display: flex;
          flex-direction: column;
          justify-content: center;

          .title {
            font-size: 16px;
            color: #134178;
          }
          .sub {
            font-size: 14px;
            color: #5e5d5d;
            margin-top: 15px;
          }
          .type {
            color: #454545;
            margin-top: 25px;
            font-weight: bold;
          }
          .info {
            color: #5e5d5d;
            font-size: 14px;
            margin-top: 15px;
            line-height: 2;
            white-space: pre-wrap;

            :deep(span) {
              font-weight: bold;
            }
          }
        }
      }
    }
    .active {
      .top {
        .point {
          background-color: #a01b1b;
        }
        .title {
          color: #333;
        }
      }
    }
  }
}
</style>
